export default "__VITE_ASSET__f408f486__"